module.exports = __webpack_public_path__ + "img/order2.a9df07cc.svg";